/** Bound coach page. Token is required unless the viewer is that store's coach. */
export function coachPath(storeId: string, token?: string): string {
  const base = `/coach/${encodeURIComponent(storeId)}`;
  return token ? `${base}?t=${encodeURIComponent(token)}` : base;
}

/** Operator click: Console session mints a store-bound token and redirects. */
export function coachOpenHref(storeId: string): string {
  return `/api/coach/stores/${encodeURIComponent(storeId)}/open`;
}
